// src/components/admin/nornsweave/StatsTab.js
import React from 'react';
import { useAdminNornsWeave } from './AdminNornsWeaveContext';

function StatsTab() {
  const {
    bookings,
    thisWeekBookings,
    fixedClasses,
    aides,
    pendingBookings
  } = useAdminNornsWeave();

  const needsLibrarianCount = thisWeekBookings.filter(b => b.needsLibrarian).length;
  const independentCount = thisWeekBookings.filter(b => !b.needsLibrarian).length;

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-2xl font-bold text-slate-800 mb-6">Booking Statistics</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl">
          <p className="text-sm text-purple-600 mb-1">Total This Week</p>
          <p className="text-4xl font-bold text-purple-700">{thisWeekBookings.length}</p>
        </div>
        <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-6 rounded-xl">
          <p className="text-sm text-indigo-600 mb-1">Needs Librarian</p>
          <p className="text-4xl font-bold text-indigo-700">{needsLibrarianCount}</p>
        </div>
        <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl">
          <p className="text-sm text-green-600 mb-1">Independent Visits</p>
          <p className="text-4xl font-bold text-green-700">{independentCount}</p>
        </div>
        <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-6 rounded-xl">
          <p className="text-sm text-slate-600 mb-1">Total All Time</p>
          <p className="text-4xl font-bold text-slate-700">{bookings.length}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-6">
        <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 p-6 rounded-xl">
          <p className="text-sm text-cyan-600 mb-1">Fixed Classes</p>
          <p className="text-4xl font-bold text-cyan-700">{fixedClasses.length}</p>
        </div>
        <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-xl">
          <p className="text-sm text-teal-600 mb-1">Library Aides</p>
          <p className="text-4xl font-bold text-teal-700">{aides.length}</p>
        </div>
        <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl">
          <p className="text-sm text-orange-600 mb-1">Pending Requests</p>
          <p className="text-4xl font-bold text-orange-700">{pendingBookings.length}</p>
        </div>
      </div>
    </div>
  );
}

export default StatsTab;
